export enum AccountingNormalBalance {
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
}
